import { render, staticRenderFns } from "./ExistingSpousalSupportAgreement.vue?vue&type=template&id=f3c4162e"
import script from "./ExistingSpousalSupportAgreement.vue?vue&type=script&lang=ts"
export * from "./ExistingSpousalSupportAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports